import React, { useState } from 'react';
import './LandingPage.css';

export default function LandingPage({ onGetStarted, onCreateAccount, onLogin, onSingleQuery }) {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: 'Preciso pagar mensalidade?',
      answer: 'Não existe mensalidade obrigatória. Você paga apenas pelas consultas que realizar, adquirindo créditos conforme a necessidade da sua empresa.'
    },
    {
      question: 'Como são cobradas as consultas?',
      answer: 'Cada tipo de consulta possui um valor específico, descontado automaticamente do saldo disponível na sua conta. Você acompanha tudo em tempo real no painel.'
    },
    {
      question: 'Os créditos possuem validade?',
      answer: 'Os créditos possuem validade de 90 dias, o bônus tem validade de 30 dias. Você também consegue recuperar créditos expirados mediante uma taxa na recarga.'
    },
    {
      question: 'Posso utilizar a plataforma para minha empresa?',
      answer: 'Sim. A plataforma pode atender profissionais e empresas de diferentes segmentos, respeitando as regras de utilização e a legislação vigente.'
    },
    {
      question: 'Como recebo o resultado?',
      answer: 'O resultado é apresentado diretamente na plataforma e permanece disponível no histórico. A validade do relatório é de 30 dias.'
    }
  ];

  const consultas = [
    {
      title: 'Consulta por CPF',
      desc: 'Localize informações cadastrais relacionadas a um CPF e tenha mais segurança para validar cadastros, contatos e negociações.',
      ideal: 'Ideal para: validação cadastral, análise de clientes e confirmação de informações.'
    },
    {
      title: 'Consulta por nome',
      desc: 'Encontre possíveis registros relacionados a uma pessoa utilizando o nome como ponto de partida para sua pesquisa.',
      ideal: 'Ideal para: localizar cadastros, complementar informações e iniciar uma busca quando você possui poucos dados.'
    },
    {
      title: 'Consulta por telefone',
      desc: 'Descubra informações relacionadas a um número de telefone e identifique possíveis dados cadastrais vinculados ao contato.',
      ideal: 'Ideal para: validar contatos, atualizar cadastros e identificar números desconhecidos.'
    },
    {
      title: 'Consulta por e-mail',
      desc: 'Pesquise informações relacionadas a um endereço de e-mail e obtenha mais dados para validar ou complementar um cadastro.',
      ideal: 'Ideal para: confirmação de identidade, enriquecimento cadastral e análise de contatos digitais.'
    },
    {
      title: 'Consulta por PIX',
      desc: 'Utilize o nome e os 6 dígitos centrais do documento exibidos em uma transação PIX para localizar possíveis informações relacionadas ao titular.',
      ideal: 'Ideal para: apoiar a identificação de pagamentos, conferir informações e reduzir dúvidas em transações.'
    }
  ];

  const beneficios = [
    {
      title: 'Evite erros cadastrais',
      desc: 'Confirme informações antes de concluir uma venda, cadastro ou atendimento.'
    },
    {
      title: 'Economize tempo',
      desc: 'Substitua processos manuais por consultas realizadas em poucos segundos.'
    },
    {
      title: 'Centralize suas consultas',
      desc: 'Acesse diferentes tipos de dados sem precisar utilizar vários sistemas.'
    },
    {
      title: 'Controle seus custos',
      desc: 'Acompanhe o consumo e pague de acordo com a utilização da plataforma.'
    }
  ];

  const segurancaItems = [
    'Controle de acesso por usuário',
    'Registro das consultas realizadas',
    'Ambiente protegido',
    'Tratamento responsável das informações',
    'Processos alinhados à LGPD'
  ];

  const paraQuem = [
    'Vendas e atendimento',
    'Análise cadastral',
    'Prevenção a fraudes',
    'Cobrança e recuperação',
    'Atualização de cadastros',
    'Imobiliárias e corretores',
    'E-commerces e marketplaces',
    'Escritórios e prestadores de serviços'
  ];

  const planos = [
    {
      creditos: '500',
      bonus: '',
      valor: 'R$ 10,00',
      texto: 'Faça 1 consulta completa por apenas R$10',
      subtexto: '500 créditos sem prazo de validade.',
      destaque: false
    },
    {
      creditos: '1.500',
      bonus: '+500',
      valor: 'R$ 30,00',
      texto: 'Faça até 4 consultas completas por apenas R$30',
      subtexto: '1.500 créditos + 500 créditos de bônus válidos por 30 dias.',
      destaque: false
    },
    {
      creditos: '3.000',
      bonus: '+2000',
      valor: 'R$ 60,00',
      texto: 'Faça até 10 consultas completas por apenas R$60',
      subtexto: '3.000 créditos + 2.000 créditos de bônus válidos por 30 dias.',
      destaque: true,
      tag: 'Mais Escolhido'
    },
    {
      creditos: '5.000',
      bonus: '+5000',
      valor: 'R$ 100,00',
      texto: 'Faça até 20 consultas completas por apenas R$100',
      subtexto: '5.000 créditos + 5.000 créditos de bônus válidos por 30 dias.',
      destaque: true,
      tag: 'Melhor Custo x Benefício'
    }
  ];

  return (
    <div className="landing-root">
      {/* Navbar */}
      <nav className="landing-navbar">
        <div className="container nav-inner">
          <div className="logo">Análise Central</div>
          <div className="nav-links">
            <a href="#como-funciona">Como funciona</a>
            <a href="#demonstracao">Demonstração</a>
            <a href="#beneficios">Benefícios</a>
            <a href="#para-quem">Para quem</a>
            <a href="#precificacao">Preços</a>
            <a href="#faq">FAQ</a>
          </div>
          <button className="nav-cta" onClick={onGetStarted}>Acessar plataforma</button>
        </div>
      </nav>

      {/* Hero */}
      <header className="landing-hero">
        <div className="hero-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="container hero-content">
          <span className="hero-badge">Plataforma de Inteligência de Dados</span>
          <h1>Consultas Cadastrais Rápidas e Seguras</h1>
          <p className="hero-subtitle">
            Encontre e valide dados em poucos segundos. Consulte informações cadastrais em uma plataforma simples, 
            segura e preparada para ajudar sua empresa a tomar decisões com mais agilidade.
          </p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={onSingleQuery}>Consultar CPF</button>
            <button className="btn-secondary" onClick={() => document.getElementById('consultas').scrollIntoView({ behavior: 'smooth' })}>
              Ver consultas disponíveis
            </button>
          </div>
          <p className="hero-note">Sem mensalidade obrigatória. Pague apenas pelas consultas realizadas.</p>
        </div>
      </header>

      {/* Features Grid */}
      <section className="features-grid">
        <div className="container">
          <div className="features-row">
            {[
              { icon: '🛡️', text: 'Dados para decisões mais seguras' },
              { icon: '⚡', text: 'Consultas realizadas em segundos' },
              { icon: '🔒', text: 'Ambiente protegido' },
              { icon: '🕐', text: 'Plataforma disponível 24 horas' },
              { icon: '💳', text: 'Pagamento por créditos' },
              { icon: '🎧', text: 'Suporte especializado' }
            ].map((f, i) => (
              <div className="feature-item" key={i}>
                <span className="feature-icon">{f.icon}</span>
                <span className="feature-text">{f.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Consultas */}
      <section id="consultas" className="consultas-section">
        <div className="container">
          <div className="section-header">
            <h2>Encontre as informações que você precisa</h2>
            <p>Pesquise por diferentes tipos de dados e encontre informações relacionadas em poucos segundos. 
               Escolha o ponto de partida que você possui e realize sua consulta de forma simples, rápida e segura.</p>
          </div>
          <div className="consultas-grid">
            {consultas.map((c, i) => (
              <div className="consulta-card" key={i}>
                <h3>{c.title}</h3>
                <p className="consulta-desc">{c.desc}</p>
                <p className="consulta-ideal">{c.ideal}</p>
                {i === 0 && (
                  <button className="btn-primary small" onClick={onSingleQuery}>Consulte Agora</button>
                )}
              </div>
            ))}
          </div>
          <div className="cta-box">
            <h3>Comece sua consulta agora</h3>
            <p>Escolha o tipo de dado que você possui, realize a pesquisa e receba as informações disponíveis diretamente na plataforma.</p>
            <button className="btn-primary" onClick={onCreateAccount}>Criar conta</button>
          </div>
        </div>
      </section>

      {/* Como Funciona */}
      <section id="como-funciona" className="como-funciona-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Como funciona</span>
            <h2>Consulte dados em três passos</h2>
          </div>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3>Crie sua conta</h3>
              <p>Faça seu cadastro de maneira rápida e segura.</p>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <h3>Adicione créditos</h3>
              <p>Escolha o valor desejado e mantenha o controle sobre seus gastos.</p>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <h3>Realize sua consulta</h3>
              <p>Informe os dados disponíveis e receba o resultado diretamente na plataforma.</p>
            </div>
          </div>
          <div className="steps-cta">
            <button className="btn-primary" onClick={onCreateAccount}>Criar conta</button>
          </div>
        </div>
      </section>

      {/* Demonstração */}
      <section id="demonstracao" className="demo-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Demonstração do produto</span>
            <h2>Uma plataforma simples, mesmo para quem não é especialista</h2>
            <p>Realize consultas, acompanhe seu histórico e controle a utilização dos créditos em um painel intuitivo.</p>
          </div>
          <div className="demo-content">
            <div className="demo-mockup">
              <div className="mockup-header">
                <div className="mockup-dots">
                  <span></span><span></span><span></span>
                </div>
                <div className="mockup-title">Painel Análise Central</div>
              </div>
              <div className="mockup-body">
                <div className="mockup-sidebar">
                  <div className="mockup-nav-item active">Dashboard</div>
                  <div className="mockup-nav-item">Consultas</div>
                  <div className="mockup-nav-item">Histórico</div>
                  <div className="mockup-nav-item">Créditos</div>
                </div>
                <div className="mockup-main">
                  <div className="mockup-card">
                    <div className="mockup-card-title">Saldo de Créditos</div>
                    <div className="mockup-card-value">R$ 1.250,00</div>
                  </div>
                  <div className="mockup-card">
                    <div className="mockup-card-title">Consultas Realizadas</div>
                    <div className="mockup-card-value">342</div>
                  </div>
                  <div className="mockup-table">
                    <div className="mockup-row header">
                      <span>Tipo</span><span>Data</span><span>Status</span>
                    </div>
                    <div className="mockup-row"><span>CPF</span><span>Hoje</span><span className="status-ok">✓</span></div>
                    <div className="mockup-row"><span>Telefone</span><span>Ontem</span><span className="status-ok">✓</span></div>
                    <div className="mockup-row"><span>PIX</span><span>Ontem</span><span className="status-ok">✓</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="demo-features">
              <div className="demo-feature">
                <span className="demo-feature-icon">📋</span>
                <div>
                  <h4>Resultado organizado e fácil de entender</h4>
                  <p>Visualize os dados de forma clara e objetiva.</p>
                </div>
              </div>
              <div className="demo-feature">
                <span className="demo-feature-icon">📜</span>
                <div>
                  <h4>Histórico das consultas realizadas</h4>
                  <p>Acesse sempre que precisar, com validade de 30 dias.</p>
                </div>
              </div>
              <div className="demo-feature">
                <span className="demo-feature-icon">💰</span>
                <div>
                  <h4>Controle de saldo e consumo</h4>
                  <p>Acompanhe seus créditos em tempo real.</p>
                </div>
              </div>
              <div className="demo-feature">
                <span className="demo-feature-icon">🚀</span>
                <div>
                  <h4>Acesso rápido às principais funcionalidades</h4>
                  <p>Tudo ao seu alcance em poucos cliques.</p>
                </div>
              </div>
              <div className="demo-feature">
                <span className="demo-feature-icon">📊</span>
                <div>
                  <h4>Relatórios disponíveis para consulta</h4>
                  <p>Baixe e compartilhe quando necessário.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="demo-cta">
            <button className="btn-primary" onClick={onCreateAccount}>Criar minha conta</button>
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section id="beneficios" className="beneficios-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">Benefícios</span>
            <h2>Mais agilidade e segurança para sua operação</h2>
          </div>
          <div className="beneficios-grid">
            {beneficios.map((b, i) => (
              <div className="beneficio-card" key={i}>
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
          <div className="consultas-slider">
            <h3 className="slider-title">Tipos de consulta disponíveis</h3>
            <div className="slider-track">
              {consultas.map((c, i) => (
                <div className="slider-card" key={i}>
                  <h4>{c.title.replace('Consulta por ', '')}</h4>
                  <p>{c.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Para quem é */}
      <section id="para-quem" className="para-quem-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">Para quem é</span>
            <h2>Feito para empresas que precisam decidir com informação</h2>
          </div>
          <p className="para-quem-intro">A plataforma pode apoiar operações de:</p>
          <div className="para-quem-grid">
            {paraQuem.map((item, i) => (
              <div className="para-quem-item" key={i}>
                <span className="pq-check">✓</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Segurança */}
      <section className="seguranca-section">
        <div className="container">
          <div className="seguranca-content">
            <div className="seguranca-text">
              <span className="section-label">Segurança</span>
              <h2>Seus dados tratados com responsabilidade</h2>
              <p>Utilizamos boas práticas de segurança para proteger o acesso à plataforma e às informações consultadas.</p>
              <ul className="seguranca-list">
                {segurancaItems.map((item, i) => (
                  <li key={i}><span className="check-icon">✓</span>{item}</li>
                ))}
              </ul>
              <p className="seguranca-note">O uso da plataforma deve respeitar a finalidade legítima da consulta e a legislação aplicável.</p>
            </div>
            <div className="seguranca-visual">
              <div className="shield-card">
                <div className="shield-icon">🛡️</div>
                <div className="shield-text">LGPD<br/>Compliance</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Planos */}
      <section className="planos-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">Planos e Créditos</span>
            <h2>Utilize de acordo com a necessidade da sua empresa</h2>
            <p>Crie sua conta gratuitamente, adicione créditos e realize consultas sem processos complicados.</p>
          </div>
          <div className="planos-grid">
            <div className="plano-card">
              <div className="plano-icon">👤</div>
              <h3>Conta gratuita</h3>
              <p>Cadastro sem custo</p>
            </div>
            <div className="plano-card">
              <div className="plano-icon">📊</div>
              <h3>Acesso ao painel</h3>
              <p>Gerencie tudo em um só lugar</p>
            </div>
            <div className="plano-card">
              <div className="plano-icon">💳</div>
              <h3>Compra de créditos</h3>
              <p>Adicione saldo quando precisar</p>
            </div>
            <div className="plano-card">
              <div className="plano-icon">📜</div>
              <h3>Histórico de consultas</h3>
              <p>Acompanhe todas as pesquisas</p>
            </div>
          </div>
          <div className="planos-cta">
            <button className="btn-primary" onClick={onCreateAccount}>Criar conta</button>
          </div>
        </div>
      </section>

      {/* ========== PREÇOS / PRECIFICAÇÃO ========== */}
      <section id="precificacao" className="precificacao-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">Precificação</span>
            <h2>Escolha o plano ideal para você</h2>
            <p>Sem mensalidade. Pague apenas pelos créditos que utilizar.</p>
          </div>

          {/* Tabela de Valores das Consultas */}
          <div className="consulta-valores-box">
            <h3 className="cv-title">💳 Valor da Consulta</h3>
            <div className="cv-grid">
              <div className="cv-item">
                <span className="cv-nome">Consulta CPF completa</span>
                <span className="cv-sep"></span>
                <span className="cv-preco">500 Créditos</span>
              </div>
              <div className="cv-item">
                <span className="cv-nome">Consulta Simples</span>
                <span className="cv-sep"></span>
                <span className="cv-preco">200 Créditos</span>
              </div>
            </div>
          </div>

          {/* Cards de Planos */}
          <div className="preco-cards-grid">
            {planos.map((plano, i) => (
              <div className={`preco-card ${plano.destaque ? 'destaque' : ''}`} key={i}>
                {plano.tag && <div className="preco-tag">{plano.tag}</div>}
                <div className="preco-creditos">
                  <span className="pc-num">{plano.creditos}</span>
                  <span className="pc-label">créditos</span>
                </div>
                {plano.bonus && (
                  <div className="preco-bonus">
                    <span className="pb-badge">{plano.bonus} BÔNUS</span>
                  </div>
                )}
                <div className="preco-valor">{plano.valor}</div>
                <p className="preco-texto">{plano.texto}</p>
                <p className="preco-sub">{plano.subtexto}</p>
                <button className="btn-primary preco-btn" onClick={onLogin}>
                  Comprar créditos
                </button>
              </div>
            ))}
          </div>

          {/* Destaques e Promoções */}
           <div className="preco-extras">
            {/*<div className="extra-card">
              <div className="extra-icon">🔄</div>
              <div className="extra-content">
                <h4>Reativar Créditos Expirados</h4>
                <p>Recupere até <strong>5.000 Créditos</strong> expirados adicionando apenas <strong>+R$ 10,00</strong> na sua recarga.</p>
              </div>
            </div> */}
            <div className="extra-card promo">
              <div className="extra-icon">🔥</div>
              <div className="extra-content">
                <h4>Promoção de Primeira Compra</h4>
                <p>Na primeira recarga, ganhe <strong>até 2x bônus</strong>! Adicione apenas <strong>+R$ 10,00</strong> na recarga e aproveite.</p>
              </div>
            </div>
          </div>

          {/* Regras */}
          {/* <div className="preco-regras">
            <p><span>📌</span> Bônus expira em <strong>30 dias</strong>.</p>
            <p><span>📌</span> Crédito expira em <strong>90 dias</strong>.</p>
            <p><span>📌</span> O sistema consome primeiro o <strong>crédito</strong>, e depois o <strong>bônus</strong>.</p>
          </div> */}
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="faq-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">Perguntas Frequentes</span>
            <h2>Tire suas dúvidas</h2>
          </div>
          <div className="faq-list">
            {faqs.map((faq, i) => (
              <div className={`faq-item ${openFaq === i ? 'open' : ''}`} key={i}>
                <button className="faq-question" onClick={() => toggleFaq(i)}>
                  <span>{faq.question}</span>
                  <span className="faq-chevron">▼</span>
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="cta-final-section">
        <div className="container">
          <div className="cta-final-box">
            <h2>Comece a consultar agora</h2>
            <p>Crie sua conta, adicione créditos e tenha acesso às informações que sua empresa precisa para tomar decisões mais rápidas e seguras.</p>
            <button className="btn-primary large" onClick={onCreateAccount}>Criar conta</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="logo">Análise Central</div>
              <p>Plataforma líder em consultas de dados com segurança e rapidez.</p>
            </div>
            <div className="footer-col">
              <h4>Serviços</h4>
              <ul>
                <li><a href="#consultas">Consulta CPF</a></li>
                <li><a href="#consultas">Consulta Telefone</a></li>
                <li><a href="#consultas">Consulta E-mail</a></li>
                <li><a href="#consultas">Consulta PIX</a></li>
                <li><a href="#consultas">Consulta Nome</a></li>
              </ul>
            </div>
            <div className="footer-col LGPD-footer">
              <h4>Empresa</h4>
              <ul>
                <li><a href="/lgpd/privacy">Política de Privacidade</a></li>
                <li><a href="/lgpd/terms">Termos de Uso</a></li>
                <li><a href="/lgpd/exclusion">Solicitação de Exclusão (LGPD)</a></li>
                <li><a href="#" onClick={onLogin}>Acessar a Plataforma</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>Caso deseje remover os seus dados da nossa base, <a href="/lgpd/exclusion">clique aqui!</a></p>
            <p className="copyright">© Análise Central. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}